import useGetProductsTableConfig from './useGetProductsTableConfig'

export default useGetProductsTableConfig
